import {
  NormalBrowseFileInputFiled,
  NormalTextEditorInputFiled,
  NormalTextInputField,
} from "@/components";
import React, { useMemo } from "react";

const InvestorsCornerFirstTabFormFields = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="business-club-heading"
            fieldName="business-club-heading"
            placeholderText="Heading"
            inputValue={formData?.["business-club-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Banner Sub Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="business-club-description"
            fieldName="business-club-description"
            placeholderText="Description"
            inputValue={formData?.["business-club-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Section Separator */}
          <div className="w-full border border-dashed border-[#00000010] dark:border-[#ffffff10] my-10" />

          {/* Feature Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Feature Section Image"
              fieldId="business-club-feature-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("business-club-feature-image", id)
                  : handleImageChange("business-club-feature-image", "")
              }
              selectedFileId={formData?.["business-club-feature-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Feature Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Feature Section Heading"
            fieldId="business-club-feature-heading"
            fieldName="business-club-feature-heading"
            placeholderText="Feature Section Heading"
            inputValue={formData?.["business-club-feature-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Feature Description */}
          <NormalTextEditorInputFiled
            isFetching={isFetching}
            labelText="Description"
            fieldId="business-club-feature-description"
            fieldName="business-club-feature-description"
            placeholderText="Description"
            inputValue={formData?.["business-club-feature-description"] || ""}
            onChangeTextEditorFiled={handleTextEditorInputChange}
            extraContainerClasses="mt-5"
            translateField={true}
          />

          {/* Section Separator */}
          <div className="w-full border border-dashed border-[#00000010] dark:border-[#ffffff10] my-10" />

          {/* Booking Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Booking Section Image"
              fieldId="business-club-booking-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("business-club-booking-image", id)
                  : handleImageChange("business-club-booking-image", "")
              }
              selectedFileId={formData?.["business-club-booking-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Booking Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Booking Section Heading"
            fieldId="business-club-booking-heading"
            fieldName="business-club-booking-heading"
            placeholderText="Booking Section Heading"
            inputValue={formData?.["business-club-booking-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Booking Email */}
          {isHideInOtherLanguages && (
            <NormalTextInputField
              isFetching={isFetching}
              labelText="Booking Section Email"
              fieldId="business-club-booking-email"
              fieldName="business-club-booking-email"
              placeholderText="Feature Section Email"
              inputValue={formData?.["business-club-booking-email"] || ""}
              onChangeTextInputField={handleTextInputChange}
              translateField={false}
              extraContainerClasses="mt-5"
            />
          )}

          {/* Section Separator */}
          <div className="w-full border border-dashed border-[#00000010] dark:border-[#ffffff10] my-10" />

          {/* Form Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Form Section Heading"
            fieldId="business-club-form-heading"
            fieldName="business-club-form-heading"
            placeholderText="Form Section Heading"
            inputValue={formData?.["business-club-form-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Form Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Form Section Description"
            fieldId="business-club-form-description"
            fieldName="business-club-form-description"
            placeholderText="Form Section Description"
            inputValue={formData?.["business-club-form-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Form Button Label */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Form Section Button Label"
            fieldId="business-club-button-label"
            fieldName="business-club-button-label"
            placeholderText="Form Section Button Label"
            inputValue={formData?.["business-club-button-label"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default InvestorsCornerFirstTabFormFields;
